import * as React from 'react';
import styled from 'styled-components';
import { ITabSwitchProps } from './TabSwitch.types';

const StyledTabSwitch = styled.div`
  background-color: transparent;
  button {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    margin: unset;
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    margin-right: 29px;
    border: unset;
    border-bottom: 2px solid transparent;
    -webkit-transition: border-color 0.3s ease-out;
    -moz-transition: border-color 0.3s ease-out;
    -o-transition: border-color 0.3s ease-out;
    transition: border-color 0.3s ease-out;
    color: ${({ theme }) => theme.colors.font1};
  }
  .button-active,
  button:hover {
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
    -webkit-transition: border-color 0.3s ease-out;
    -moz-transition: border-color 0.3s ease-out;
    -o-transition: border-color 0.3s ease-out;
    transition: border-color 0.3s ease-out;
  }
`;

const TabSwitch: React.FC<ITabSwitchProps> = (props: ITabSwitchProps) => {
  const { options, onChange, className, testId } = props;
  const [actualTabKey, setActualTabKey] = React.useState(
    options && options.length ? options[0].key : ''
  );

  return (
    <StyledTabSwitch
      className={`${className}`}
      data-testid={testId || 'tab-switch'}
    >
      {options.map(option => {
        return (
          <button
            type="button"
            key={`step-${option.key}`}
            className={actualTabKey === option.key ? 'button-active' : ''}
            onClick={e => {
              e.preventDefault();
              setActualTabKey(option.key);
              if (onChange) {
                onChange(option);
              }
            }}
          >
            {option.title}
          </button>
        );
      })}
    </StyledTabSwitch>
  );
};

export default TabSwitch;
